import type { ActivityType } from '../../../typings'
import type { UpdateActivityType } from './typings'

export const updateActivityTypeActionCreator = (
  payload?: ActivityType,
): UpdateActivityType => ({ type: 'activityTypes/update', payload })
